import React from 'react'
import { emptyStateVariants } from '../styles'
import { Button } from '@tecsinapse/cortex-react'
import { FiAlertCircle } from 'react-icons/fi'

export interface EmptyStateProps {
  title?: string
  message?: string
  buttonText?: string
  onClickButton?: () => void
}

const { container, titleStyle, messageStyle, button, icon } = emptyStateVariants()

const EmptyState = ({
  title = 'Nada por aqui',
  message = 'Não existem dados para exibição',
  buttonText,
  onClickButton
}: EmptyStateProps) => {
  const renderButton = buttonText && onClickButton

  return (
    <div className={container()}>
      <FiAlertCircle className={icon()} />
      <div className={titleStyle()}>{title}</div>
      {message ? <div className={messageStyle()}>{message}</div> : <></>}
      {renderButton ? (
        <Button
          className={button()}
          variants={{
            size: 'small'
          }}
          onClick={onClickButton}
        >
          <p>{buttonText}</p>
        </Button>
      ) : (
        <></>
      )}
    </div>
  )
}

export default EmptyState
